import {Visibility} from 'common/components/base/stackable';

export interface ModalAttrs {
  closeable: boolean;
  'grow-to-content': boolean;
  'hide-close-button': boolean;
  'modal-type': string;
  'modal-title': string;
  'modal-description': string;
  'not-fullscreen': boolean;
  open: boolean;
}

export interface ModalState {
  visibility: string;
}

export type ModalChangeEvent = CustomEvent<{state: Visibility}>;

export enum ExportDashboardModalPage {
  Main = `main`,
  ConfirmExternalUsers = `confirm-external-users`,
}
